import type { ReactNode } from 'react'
import { ErrorState, EmptyState } from './Status'
import { Skeleton } from '../ui/skeleton'
import { cn } from '../../lib/utils'

/** 查询三态包装：loading 骨架 / error 错误态 / 空数据空态 / 正常渲染 */
export function QueryBoundary<T>({ query, skeleton, isEmpty, empty, children, className }: {
  query: { isPending: boolean; isError: boolean; error: Error | null; refetch: () => void; data: T | undefined }
  skeleton?: ReactNode
  isEmpty?: (data: T) => boolean
  empty?: { title: string; description?: string; icon?: ReactNode }
  children: (data: T) => ReactNode
  className?: string
}) {
  if (query.isPending) {
    return <div className={className}>{skeleton ?? <DefaultSkeleton />}</div>
  }
  if (query.isError) {
    return <div className={className}><ErrorState message={query.error?.message ?? '加载失败'} retry={() => query.refetch()} /></div>
  }
  if (query.data == null || (isEmpty?.(query.data) ?? false)) {
    return <div className={className}>{empty ? <EmptyState {...empty} /> : <EmptyState title="暂无数据" />}</div>
  }
  return <div className={cn(className)}>{children(query.data)}</div>
}

function DefaultSkeleton() {
  return (
    <div className="space-y-2 p-4">
      <Skeleton className="h-4 w-1/3" />
      <Skeleton className="h-4 w-2/3" />
      <Skeleton className="h-4 w-1/2" />
    </div>
  )
}
